import { render, staticRenderFns } from "./PostMappingList.vue?vue&type=template&id=33c8a78a&scoped=true"
import script from "./PostMappingList.vue?vue&type=script&lang=js"
export * from "./PostMappingList.vue?vue&type=script&lang=js"
import style0 from "./PostMappingList.vue?vue&type=style&index=0&id=33c8a78a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8a78a",
  null
  
)

export default component.exports